module.exports = __webpack_public_path__ + "img/icon-check-circle.60b3ef46.svg";